// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PointIconResource extends Resource {
    basePath: string = 'addresses/point-icon/';

    objectPath: string = 'addresses/point-icon/{ident}/';

    static getPointIconUrl(icon: string, color: string, focused: boolean = false): string {
        const url = `${process.env.REACT_APP_API_ROOT}addresses/point-icon/get_svg_icon/`
            + `?icon=${icon}&color=${encodeURIComponent(color)}`;

        if (focused) {
            return `${url}&focused=true`;
        }

        return url;
    }
}
